import { ValidationResult } from "./buildValidationResult";

export const ZOD_VALIDATION_RESULT_PREFIX = "validationResult.";

type BuildZodValidationResultOptions = {
  pathMapping?: Record<string, string>;
};

export function buildZodValidationResult(
  result: ValidationResult,
  options?: BuildZodValidationResultOptions,
) {
  const path = options?.pathMapping?.[result.path] || result.path;
  return {
    code: "custom" as const,
    message: `${ZOD_VALIDATION_RESULT_PREFIX}${JSON.stringify({
      ...result,
      path,
    })}`,
    path: [path],
  };
}
